import { type IXSLXImport } from '@principle-theorem/shared';
import type { Row } from 'exceljs';
import {
  type IReferralSourceXSLX,
  REFERRAL_SOURCE_HEADERS,
} from './referral-sources-to-xlsx';

export class XSLXToReferralSources implements IXSLXImport<IReferralSourceXSLX> {
  headers = REFERRAL_SOURCE_HEADERS;

  translate(row: Row): IReferralSourceXSLX {
    return {
      sourceId: row.getCell('sourceId').value?.toString() ?? '',
      sourceName: row.getCell('sourceName').value?.toString() ?? '',
      mapTo: row
        .getCell('mapTo')
        .value?.toString() as IReferralSourceXSLX['mapTo'],
    };
  }
}
